/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Punith Mithra',
        title: 'Team Lead, one.com',
        text: `He possesses a profound expertise in a lot of technologies, including React, Redux, JavaScript, and Node.js, which he flawlessly applied in our large-scale projects.`,
        image: boy1
    },
    {
        id: 2,
        name: 'Shubham Agarwal',
        title: 'SSE, one.com',
        text: "During a migration project at one.com he showed tremendous skill and lead from the front guiding the whole team to achieve tremendous results in record time.",
        image: boy2
    },
    {
        id: 3,
        name: 'Hemanth Sanareddy',
        title: 'UI Lead, Syncro',
        text: "Abhilash Sandi proved to be an exceptionally reliable colleague, consistently delivering outstanding work for the team",
        image: boy3
    }
]

